;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.controllers')
    .controller('ModifyController', ModifyController)

  ModifyController.$inject = [
    // Angular
    '$uibModalInstance', '$http', 'urls',
    // Managers
    'CategoryManager',
    // Resolve
    'ids'

  ]

  function ModifyController (
    // Angular
    $uibModalInstance, $http, urls,
    // Managers
    CategoryManager,
    // Resolve
    ids

  ) {
    var self = this
    self.$onInit = () => {
      _.extend(self, {
        cancel: cancel,
        validate: validate
      })
    }
    this.options = [
      { key: 'reference', value: 'Référence' },
      { key: 'label', value: 'Désignation' },
      { key: 'unit', value: 'Unité' },
      { key: 'defaultQuantity', value: 'Quantité par défaut' },
      { key: 'category', value: 'Catégorie' },
      { key: 'bpu', value: 'BPU' },
      { key: 'VAT', value: 'TVA' },
      { key: 'price', value: 'Prix H.T.' },
      { key: 'type', value: 'Type' },
      { key: 'description', value: 'Description' },
      { key: 'files', value: 'Fichiers' },
      { key: 'image', value: 'Photo' }
    ]

    function validate (type, value) {
      if (self.saveCategory) {
        CategoryManager.create({ label: value }).save()
      }
      const url = urls.api + '/kilo/products/bulkProductModification'
      $http.put(url, { ids: ids, type: type, value: value }).then(() => {
        $uibModalInstance.close()
      })
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

  }
})(window.angular, window._)
